module.exports = {
	"config": {
		"siteTitle": "Adam Krogh",
		"googleAnalyticsId": "UA-101191266-1",
		"linkPrefix": "/",
		"resumeUrl": "https://cdn.adamkrogh.com/AdamKrogh_Resume.pdf"
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.js",
				"ext": "js",
				"name": "_template",
				"extname": ".js",
				"basename": "_template.js",
				"dirname": "",
				"stem": "_template",
				"path": "_template.js"
			},
			"requirePath": "_template.js",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.js",
				"ext": "js",
				"name": "404",
				"extname": ".js",
				"basename": "404.js",
				"dirname": "",
				"stem": "404",
				"path": "404.js"
			},
			"requirePath": "404.js",
			"path": "/404.html",
			"data": {
				"path": "/404.html"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "about",
				"base": "_template.js",
				"ext": "js",
				"name": "_template",
				"extname": ".js",
				"basename": "_template.js",
				"dirname": "about",
				"stem": "_template",
				"path": "about/_template.js"
			},
			"requirePath": "about/_template.js",
			"templatePath": "/about/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "about",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "about",
				"stem": "index",
				"path": "about/index.js"
			},
			"requirePath": "about/index.js",
			"path": "/about/",
			"data": {
				"title": "About",
				"description": "(Krogh rhymes with \"rogue\")",
				"path": "/about/",
				"color": "#26A65B"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "",
				"stem": "index",
				"path": "index.js"
			},
			"requirePath": "index.js",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "projects",
				"base": "_template.js",
				"ext": "js",
				"name": "_template",
				"extname": ".js",
				"basename": "_template.js",
				"dirname": "projects",
				"stem": "_template",
				"path": "projects/_template.js"
			},
			"requirePath": "projects/_template.js",
			"templatePath": "/projects/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "projects/247-edmonton",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "projects/247-edmonton",
				"stem": "index",
				"path": "projects/247-edmonton/index.js"
			},
			"requirePath": "projects/247-edmonton/index.js",
			"path": "/projects/247-edmonton/",
			"data": {
				"id": 2,
				"title": "24/7 Edmonton",
				"layout": "project",
				"path": "/projects/247-edmonton/",
				"category": "c#, ionic, angular",
				"color": "#F5A72D",
				"inverse": true,
				"image": "247edmonton-screen.png",
				"description": "Apps for helping outreach workers remotely update case information and track program statistics."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "projects/neuromembrane",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "projects/neuromembrane",
				"stem": "index",
				"path": "projects/neuromembrane/index.js"
			},
			"requirePath": "projects/neuromembrane/index.js",
			"path": "/projects/neuromembrane/",
			"data": {
				"id": 3,
				"title": "Neuromembrane",
				"layout": "project",
				"path": "/projects/neuromembrane/",
				"category": "python, canvas api",
				"color": "#8E44AD",
				"image": "neuron-screen.png",
				"description": "An educational simulator designed to teach students about neuroscience concepts."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "projects/snazzy-maps",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "projects/snazzy-maps",
				"stem": "index",
				"path": "projects/snazzy-maps/index.js"
			},
			"requirePath": "projects/snazzy-maps/index.js",
			"path": "/projects/snazzy-maps/",
			"data": {
				"id": 1,
				"title": "Snazzy Maps",
				"layout": "project",
				"path": "/projects/snazzy-maps/",
				"category": "c#, react",
				"color": "#118850",
				"image": "snazzy-maps-screen.png",
				"description": "A community centered around creating and sharing beautiful styles for Google Maps."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "projects/tripitty",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "projects/tripitty",
				"stem": "index",
				"path": "projects/tripitty/index.js"
			},
			"requirePath": "projects/tripitty/index.js",
			"path": "/projects/tripitty/",
			"data": {
				"id": 4,
				"title": "Tripitty",
				"layout": "project",
				"path": "/projects/tripitty/",
				"category": "c#, jquery",
				"color": "#2DABF0",
				"image": "tripitty-screen.png",
				"description": "A web app for helping avid travellers track and share their world travel."
			}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 385
// module chunks = 0